<template>
  <li class="wf-flex wf-flex-wrap wf-flex-row wf-items-center wf-w-full wf-py-2">
    <span class="wf-w-1/2 wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide">Direction</span>
    <select v-model="direction" class="wf-w-1/2 wf-text-xs">
      <option value="FLEX_ROW">horizontal</option>
      <option value="FLEX_COL">vertical</option>
    </select>
  </li>
</template>

<script>
  import { FlexClasses } from '../classes/FlexClasses'
  import MenuStyleProperty from '../contracts/MenuStyleProperty'
  import EmitsPropertyEvent from '../mixins/EmitsPropertyEvent'
  export default MenuStyleProperty.extend({
    mixins: [EmitsPropertyEvent],
    watch: {
      direction(value) {
        this.emitPropertyEvents(value)
      }
    },
    computed: {
      directionClasses() {
        return Object.keys(FlexClasses)
      },
      direction: {
        get() {
          let direction = this.elementClasses(this.classes)[this.device].find(elementClass => this.directionClasses.includes(elementClass.value))
          if (! direction) {
            direction = {property: 'Flex', value: 'FLEX_ROW', touched: false}
            this.addToArray(this.module, [direction], this.classes, this.device, {}, true, this.parentModule)
          }
          return direction.value
        },
        set(value) {
          let currentDirection = this.elementClasses(this.classes)[this.device].find(elementClass => this.directionClasses.includes(elementClass.value))
          value = {property: 'Flex', value: value, touched: currentDirection.touched}
          this.addToArray(this.module, [value], this.classes, this.device, {}, true, this.parentModule)
        }
      },
    }
  })
</script>